// extracted by mini-css-extract-plugin
export default {"headerContainer":"IsaacPdfHeader_headerContainer__7zVw3","headerNote":"IsaacPdfHeader_headerNote__NWBdb","onlyPrint":"IsaacPdfHeader_onlyPrint__BqD2J"};